// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c352bb82","952":"22155d26"}[chunkId] + ".chunk.js";
};